import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Flex, AccordionList, Accordion } from 'onefaceui-react-components';

import { getResourceTo } from 'react/utils/utils';

const Reason = ({ stop, routeId, stopId }) => {
  const reasonCode = useMemo(() => {
    const reason = stop.get('undeliverableCode', stop.get('cancelCode'));

    return reason ? reason.get('description') : '';
  }, [stop, routeId, stopId]);

  return (
    reasonCode && (
      <AccordionList>
        <Accordion dataTestId="reason" label={getResourceTo('Stop.popup.motivo')}>
          <Flex alignItems="center" className="reason-item">
            <div>{reasonCode}</div>
          </Flex>
        </Accordion>
      </AccordionList>
    )
  );
}

Reason.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  stop: PropTypes.object.isRequired
}

export default Reason;
